import type { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'AppPart',
	loadComponent: () => import('./AppPart.js' /* webpackChunkName: "AppPart" */),
}

export default entry
